import { useState, useEffect, useCallback } from 'react';
import { apiSwaggerClientSide } from '@/shared/api';
import { StatsSummary } from '@/sharedTypes/Api';

interface UseStatsSummaryResult {
  summary: StatsSummary | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useStatsSummary(enabled: boolean): UseStatsSummaryResult {
  const [summary, setSummary] = useState<StatsSummary | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = useCallback(async () => {
    if (!enabled) return;

    setLoading(true);
    setError(null);

    try {
      const response = await apiSwaggerClientSide.api.statsSummaryList();
      if (response.data) {
        setSummary(response.data);
      }
    } catch (err) {
      console.error('[useStatsSummary] Error fetching stats:', err);
      setError('Failed to fetch stats');
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return { summary, loading, error, refetch: fetchStats };
}
